import request from '../../../shared/request'

export function getJobVendors(job_id) {
  return request(`/job/job_vendors/${job_id}/`)
}

export function createJobVendor(payload) {
  return request(`/job/job_vendors/${payload.job_vendor_id}/`, {
    method: 'POST',
    body: payload,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}

export function updateJobVendor(payload) {
  return request(`/job/job_vendors/${payload.job_vendor_id}/`, {
    method: 'PUT',
    body: payload,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}

export function deleteJobVendor(payload) {
  return request(`/job/job_vendors/${payload.jobId}/${payload.organizationId}`, {
    method: 'DELETE',
    body: payload,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}

export function getAllVendors() {
  return request(`/vendor/`)
}

export function addJobVendor(payload) {
  return request(`/job/job_vendors/${payload.job_id}/`, {
    method: 'POST',
    body: payload,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}

export function createVendorPurchaseOrder(payload) {
  return request(`/vendor/purchase_orders/${payload.job_id}/`, {
    method: 'POST',
    body: payload,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}

export function updateVendorPurchaseOrder(payload) {
  return request(`/vendor/purchase_orders/${payload.purchase_order_id}/`, {
    method: 'PUT',
    body: payload,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}

export function getVendorPurchaseOrder(job_id) {
  return request(`/vendor/purchase_orders/${job_id}`)
}

export function uploadAttachments(payload) {
  return request(`/job/job_vendors/${payload.jobId}/attachment`, {
    method: 'POST',
    body: payload.formData,
    headers: {
      'content-type': 'multipart/form-data'
    }
  })
}

export function getAttachments(params) {
  return request(`/job/job_vendors/${params.organizationId}/${params.jobId}/attachments/`)
}

export function updateAttachmentDescription(payload) {
  return request(`/job/job_vendors/${payload.attachmentId}/attachment`, {
    method: 'PUT',
    body: payload,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}

export function deleteAttachment(payload) {
  return request(`/job/job_vendors/attachment/delete/${payload.attachmentId}/`, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}

export function quickAddVendor(payload) {
  return request(`/company/`, {
    method: 'POST',
    body: payload,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}

export function deletePurchaseOrder(payload) {
  return request(`/vendor/purchase_orders/${payload.purchaseOrderId}/`, {
    method: 'DELETE',
    body: payload,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}



// WEBPACK FOOTER //
// ./src/redux/api/job/vendors.js